import React, { FC, useEffect, useMemo, useState } from 'react';
import {
  AnswerType3,
  AnswerType4,
  AnswerType6,
  AnswerType6Option,
  QuestionType,
  QuizQuestion,
} from '../../shared/types';
import { CardTemplate5 } from '../cardTemplates/cardTemplate5';
import { CardTemplate8 } from '../cardTemplates/cardTemplate8';
import { CardTemplate6 } from '../cardTemplates/cardTemplate6';
import { CardTemplate7 } from '../cardTemplates/cardTemplate7';
import { shuffleAnswersType17, shuffleAnswersType5, shuffleAnswersType8 } from '../../shared/utils';
import { CardTemplate16 } from '../cardTemplates/cardTemplate16';
import { CardTemplate15 } from '../cardTemplates/cardTemplate15';
import { CardTemplate17 } from '../cardTemplates/cardTemplate17';

type Props = {
  data: QuizQuestion;
  handleAnswer: (id: string, isCorrect: boolean) => void;
  isSubmitted: boolean;
  handleChangeQuestion: () => void;
};
export const MultipleAnswerCard: FC<Props> = ({ data, handleAnswer, handleChangeQuestion, isSubmitted }) => {
  const isType5 = data.qs_type === QuestionType.Five;
  const isType6 = data.qs_type === QuestionType.Six;
  const isType7 = data.qs_type === QuestionType.Seven;
  const isType8 = data.qs_type === QuestionType.Eight;
  const isType15 = data.qs_type === QuestionType.Fifteen;
  const isType16 = data.qs_type === QuestionType.Sixteen;
  const isType17 = data.qs_type === QuestionType.Seventeen;

  const [answersState, setAnswersState] = useState<AnswerType3[]>([]);
  const [type5AnswersState, setType5AnswersState] = useState<AnswerType4[]>([]);
  const [type17AnswersState, setType17AnswersState] = useState<string[]>([]);

  const submitDisabled = useMemo(
    () => (isType16 || isType15) && type5AnswersState.some((answ) => !answ.correct),
    [isType16, isType15, type5AnswersState]
  );

  const checkIsIncorrect = () => {
    if (isType5 || isType16 || isType15) {
      const values = Object.values(data.paramjs);
      return values.some((item, index) => item.correct.trim() !== type5AnswersState[index].correct.trim());
    } else if (isType17) {
      const trueOptions = (data.paramjs as AnswerType6)?.options?.map((option) => option.value);
      return JSON.stringify(type17AnswersState) !== JSON.stringify(trueOptions);
    } else {
      const values = data.paramjs as AnswerType3[];
      return values.some((item, index) => item.answer.trim() !== answersState[index].answer.trim());
    }
  };

  const handleSubmit = () => {
    const isIncorrect = checkIsIncorrect();
    handleAnswer(data.id, !isIncorrect);
  };

  useEffect(() => {
    if (isType5) {
      const values = Object.values(data.paramjs);
      const mixedValues = shuffleAnswersType5(values);
      setType5AnswersState(mixedValues);
    } else if (isType16 || isType15) {
      const values = Object.values(data.paramjs);
      setType5AnswersState(values.map((val) => ({ ...val, correct: '' })));
    } else if (isType17) {
      setType17AnswersState((data.paramjs as AnswerType6)?.options?.map((opt) => ''));
    } else if (isType8) {
      const values = data.paramjs as AnswerType3[];
      const mixedValues = shuffleAnswersType8(values);
      setAnswersState(mixedValues);
    } else {
      setAnswersState((data.paramjs as AnswerType3[]).map((item) => ({ ...item, answer: '' })));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.id]);

  return (
    <div className="py-4 px-2 px-sm-4 rounded-2 text-center bg-white tw-shadow-[0_0_50px_-12px_rgb(0,0,0,0.4)]">
      {isType5 && (
        <CardTemplate5
          data={data}
          isSubmitted={isSubmitted}
          answersState={type5AnswersState}
          setAnswersState={setType5AnswersState}
        />
      )}
      {isType6 && (
        <CardTemplate6
          data={data}
          isSubmitted={isSubmitted}
          answersState={answersState}
          setAnswersState={setAnswersState}
        />
      )}
      {isType7 && (
        <CardTemplate7
          data={data}
          isSubmitted={isSubmitted}
          answersState={answersState}
          setAnswersState={setAnswersState}
        />
      )}
      {isType8 && (
        <CardTemplate8
          data={data}
          isSubmitted={isSubmitted}
          answersState={answersState}
          setAnswersState={setAnswersState}
        />
      )}
      {isType15 && (
        <CardTemplate15
          data={data}
          isSubmitted={isSubmitted}
          answersState={type5AnswersState}
          setAnswersState={setType5AnswersState}
        />
      )}
      {isType16 && (
        <CardTemplate16
          data={data}
          isSubmitted={isSubmitted}
          answersState={type5AnswersState}
          setAnswersState={setType5AnswersState}
        />
      )}
      {isType17 && (
        <CardTemplate17
          data={data}
          isSubmitted={isSubmitted}
          answersState={type17AnswersState}
          setAnswersState={setType17AnswersState}
        />
      )}
      {!isSubmitted ? (
        <button
          className="btn btn-primary px-5 font-bold tw-w-full min-[400px]:tw-w-[220px] sm:!tw-text-xl"
          onClick={handleSubmit}
          disabled={submitDisabled}
        >
          ТЕКСЕРУ
        </button>
      ) : (
        <button
          className="btn btn-outline-primary px-5 font-bold tw-w-full min-[400px]:tw-w-[220px] sm:!tw-text-xl"
          onClick={handleChangeQuestion}
        >
          КЕЛЕСІ
        </button>
      )}
    </div>
  );
};
